// extracted by mini-css-extract-plugin
export default {"title":"documents_title__-2T87","pdf-preview":"documents_pdf-preview__uV2jG"};